import React, {useContext} from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@material-ui/core';
import {useSnackbar} from 'notistack';
import {AppContext} from "../../shared/context";
import {desativar} from "../../../services/usuario/UsuarioService";

const DesativarPerfil = (props) => {

  const { open, onClose, id, tipoPerfil } = props;
  const { enqueueSnackbar } = useSnackbar();
  const { keycloak } = useContext(AppContext);



  const handleDesativarPerfil = async () => {

    let response = undefined;

    //todo corrigir
    let idUsuarioPerfil =0;
    response = await desativar(id, idUsuarioPerfil);

    if (response.status === 200) {
      enqueueSnackbar('Perfil desativado com sucesso!', { variant: 'success' })
      onClose();
    }

  }
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Desativar Perfil</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Tem certeza que deseja desativar esse perfil?
          Essa ação não pode ser desfeita
          </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="outlined"
          onClick={onClose}
        >
          Cancelar
          </Button>
        <Button
          color="secondary"
          type="button"
          variant="contained"
          onClick={handleDesativarPerfil}
          disabled={true}
        >
          Desativar Perfil
         </Button>
      </DialogActions>
    </Dialog>
  );
}


export default DesativarPerfil;
